export const TOGGLE_SIDE_NAV = "TOGGLE_SIDE_NAV";
export const TOGGLE_SIDE_NAV_GROUP = "TOGGLE_SIDE_NAV_GROUP";
const WINDOW_RESIZE = "WINDOW_RESIZE";
